var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('button',{staticClass:"product__sound",class:_vm.classObject,on:{"click":_vm.playSound}},[_c('app-icon',{staticClass:"icon",attrs:{"icon":"sound","size-px":"18px"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }